import setCrisisAllocation from './setCrisisAllocation';
import setCrisisCalls from './setCrisisCalls';
import setCrisisCallTeamMembers from './setCrisisCallTeamMembers';
import setAllocationsFilter from './setAllocationsFilter';

export default {
  setCrisisAllocation,
  setCrisisCalls,
  setCrisisCallTeamMembers,
  setAllocationsFilter,
};
